import ManagePortionTable from './ManagePortionTable'
import ManagePortionDetails from './ManagePortionDetails'

const ManagePortion = {
  Table: ManagePortionTable,
  Details: ManagePortionDetails,
}

export default ManagePortion
